import {createLazyFileRoute} from '@tanstack/react-router'

import FoodGrubhubRestaurantDetail from '@/views/FoodGrubhubRestaurantDetail/FoodGrubhubRestaurantDetail'

export const Route = createLazyFileRoute('/_food-grubhub/restaurant/$restaurantId/')({
  component: FoodGrubhubRestaurantDetail,
})
